import http from '../const/http-common'

const getTemplate = () => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.get('/v1/user/chat/templates', { headers });
}

const getDefaultKey = () => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.get('/v1/setting/key/default/get', { headers });
}

const setDefaultKey = (info) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }

  return http.post('/v1/setting/key/default/set', info, { headers });
}
const utilService = {
  getTemplate,
  getDefaultKey,
  setDefaultKey
}

export default utilService